export default __webpack_public_path__ + "static/made-okine-sans-regular-outline-f05ff5eb0568d17207deb58ccea555b0.woff2";